import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-validation',
  templateUrl: './auth-validation.component.html',
  styleUrls: ['./auth-validation.component.scss'],
})
export class AuthValidationComponent implements OnInit {
  @Input() message: string | undefined;

  constructor() {}

  ngOnInit(): void {}
}
